import { http } from '@/plugins/http';

export const loadInitData = ({ dispatch }, query) => {
  dispatch('setFetching', { key: 'brands', value: true });
  dispatch('setFetching', { key: 'models', value: true });

  return http
    .get('/filter/used/init-data/' + (query ? '?' + query : ''))
    .then(data => {
      dispatch('setData', { key: 'brands', value: data.data.brands });
      dispatch('setData', { key: 'models', value: data.data.models });
      dispatch('setFetching', { key: 'brands', value: false });
      dispatch('setFetching', { key: 'models', value: false });
    })
    .catch(() => {
      dispatch('setFetching', { key: 'brands', value: false });
      dispatch('setFetching', { key: 'models', value: false });
    });
}

export const loadModelsAndSubmodels = ({ dispatch }, brandIds) => {
  dispatch('setFetching', { key: 'models', value: true });

  const query = brandIds.map(id => `brand[]=${id}`).join('&');

  return http
    .get('/filter/used/models/' + (query ? `?${query}` : ''))
    .then(data => {
      dispatch('setData', { key: 'models', value: data.data.models });
      dispatch('setFetching', { key: 'models', value: false });
    })
    .catch(() => {
      dispatch('setFetching', { key: 'models', value: false });
    });
}
